module.exports = __webpack_public_path__ + "img/huodong_title_time@2x.5ce10a12.png";